export default "__VITE_ASSET__b7bfb5ab__"